export const elementConstants = {
    GETALL_ELEMENTS_REQUEST: 'GETALL_ELEMENTS_REQUEST',
    GETALL_ELEMENTS_SUCCESS: 'GETALL_SUCCESS',
    GETALL_ELEMENTS_FAILURE: 'GETALL_ELEMENTS_FAILURE',

    UPDATE_ELEMENT_REQUEST: 'UPDATE_ELEMENT_REQUEST',
    UPDATE_ELEMENT_SUCCESS: 'UPDATE_ELEMENT_SUCCESS',
    UPDATE_ELEMENT_FAILURE: 'UPDATE_ELEMENT_FAILURE',

    
    CREATE_ELEMENT_REQUEST: 'CREATE_ELEMENT_REQUEST',
    CREATE_ELEMENT_SUCCESS: 'CREATE_ELEMENT_SUCCESS',
    CREATE_ELEMENT_FAILURE: 'CREATE_ELEMENT_FAILURE',

    ADD_TO_LIST_SUCCESS: 'ADD_TO_LIST_SUCCESS',
    UPDATE_LIST_SUCCESS: 'UPDATE_LIST_SUCCESS',
    ADD_TO_LIST_SUCCESS: 'ADD_TO_LIST',
/*     ATTACH_REQUEST: 'ATTACH_REQUEST' ,
    ATTACH_SUCCESS: 'ATTACH_SUCCESS',
    ATTACH_FAILURE: 'ATTACH_FAILURE' */
    QUESTION: 1,
    FIELD: 2,
    EVENT: 3,
    CONTAINER: 4,
    CONTENT: 5,
    PAYMENT_OPTIONS:6,
 
    ARTICLE:8,
    INVOICE_FIELD:9,
    USER_PAGE: 10,
    PRE_CONFIRMATION: 11,
    DELETED: 12,
    PROFILEIMAGE_UPLOAD: 13,
    DISCOUNT: 14,
    GROUP_REGISTRATION: 15,
    FILE_UPLOADER: 16
    //and so on
};